// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rN-z","twoColumnImage":"sN-z"};